/*=============================================================================================
*
*      JS for carousel for the /centers/
*      Carousel is located in partials/carousels/centers-thumbnail-carousel.html
*      CSS and JS are loaded through respective Assets/main files
*      Author: ABLE Dev
==============================================================================================*/

import Swiper from 'swiper';

import SwiperCore, { Pagination, EffectFade } from 'swiper/core';

SwiperCore.use([ Pagination, EffectFade ]);

export function newsSlider() {
    var swiper = new Swiper(".news-slider", {
        slidesPerView: 1,
        initialSlide: 0,
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        pagination: {
          el: ".news-swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return '<div class="' + className + '"></div>';
          },
        },
    });
};